import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

import AffiliateBanner from '../../assets/images/affiliate_home_2.png';
import AffiliateEarnMoneyBannerImg from '../../assets/images/earn_money_banner.png';
import BagImg from '../../assets/icons/bag.png';
import LigthningImg from '../../assets/icons/lightning.png';
import MapImg from '../../assets/icons/map.png';
import RoutePaths from '../../configs/Routes';
import CanamPDF from '../../assets/documents/canam-affiliate-packet.pdf'

const AffiliatesBanner = () => (
    <Grid
      container
      sx={{
        minHeight: { xs: '50vh', md: '120vh'},
        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0,0,0,0)), url(${AffiliateBanner})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        alignItems: 'center',
        justifyContent: 'flex-start',
        px: { xs: 2, sm: 4, md: 8 },
        py: { xs: 6, md: 0 },
      }}
    >
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          mt: { xs: 0, md: -25 },
          px: { xs: 1, sm: 2 },
        }}
      >
        <Typography
          variant="h3"
          fontWeight={700}
          color="white"
          fontFamily='"Archivo Black", sans-serif'
          fontSize={{ xs: '28px', sm: '36px', md: '70px' }}
          lineHeight={1.1}
        >
          Turn Referrals<br />
          into Earnings<br />
        </Typography>

        <Typography
          color="white"
          fontWeight={400}
          fontFamily="Lato"
          fontSize={{ xs: '13px', sm: '16px', md: '30px' }}
          mt={1}
        >
          Join the CanAm Affiliate Program Today
        </Typography>

        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start"
          sx={{ mt: 3 }}
        >
          <Grid item>
            <img src={MapImg} alt="Map" width={30} height={30} />
          </Grid>
          <Grid item>
            <Typography color="white" fontSize="0.9rem" fontWeight={500}>
              Tracked <br /> in Real Time
            </Typography>
          </Grid>
          <Grid item>
            <img src={LigthningImg} alt="Lightning" width={20} height={30} />
          </Grid>
          <Grid item>
            <Typography color="white" fontSize="0.9rem" fontWeight={500}>
              Fast <br /> Payments
            </Typography>
          </Grid>
          <Grid
          container
          direction="row"
          alignItems="center"
          spacing={1}
          width={{ xs: 200 }}
          mt={{xs: 2}}
          px={2}
        >
          <Grid item>
            <img src={BagImg} alt="Bag" style={{ width: 24 }} height={30} />
          </Grid>
          <Grid item>
            <Typography color="white" fontSize="0.9rem" fontWeight={500}>
              Built for Travel <br /> Pros & Locals
            </Typography>
          </Grid>
        </Grid>
        </Grid>
        <Button
          variant="contained"
          color="primary"
          href={CanamPDF}
          component="a"
          download
          disableElevation
          sx={{
            mt: 4,
            px: 4,
            py: 1.5,
            borderRadius: '50px',
            backgroundColor: '#15B5E8',
            fontWeight: 700,
            fontFamily: 'Lato',
            fontSize: { xs: '0.85rem', md: '1rem' },
          }}
        >
          Download The Packet
        </Button>
      </Grid>
    </Grid>
  );

const AffiliateEarnMoneyBanner = () => (
    <Box my={4}>
      <Grid container direction={{ xs: 'column', md: 'row' }}>
        {/* Left Image */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            background: `url(${AffiliateEarnMoneyBannerImg}) no-repeat center`,
            backgroundSize: 'cover',
            height: { xs: '250px', sm: '300px', md: '80vh' },
            display: { xs: 'block', md: 'block' },
          }}
        />

        {/* Right Content */}
        <Grid
          item
          xs={12}
          md={6}
          container
          direction="column"
          justifyContent="center"
          alignItems={{ xs: 'center', md: 'flex-start' }}
          sx={{
            backgroundColor: '#fff',
            px: { xs: 2, sm: 3, md: 4 },
            py: 4,
          }}
        >
          <Typography
            variant="h4"
            fontWeight={700}
            fontFamily="Raleway"
            sx={{ textAlign: { xs: 'center', md: 'start' }, mb: 3 }}
          >
            Promote Excursions and Earn Money as a CanAm Partner
          </Typography>
          <Button
            variant="contained"
            LinkComponent={Link}
            to={RoutePaths.SIGN_UP}
            color="primary"
            disableElevation
            sx={{
              px: 4,
              py: 1.5,
              fontWeight: 600,
              fontFamily: 'Lato',
              borderRadius: '50px',
            }}
          >
            Register Now
          </Button>
        </Grid>
      </Grid>
    </Box>
  );

export { AffiliatesBanner, AffiliateEarnMoneyBanner };
